export default __webpack_public_path__ + "static/media/img27.27731e72.jpg";